module.exports = __webpack_public_path__ + "static/img/clothing_06.d205390.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_06.png
// module id = m0XK
// module chunks = 0